<section2 [title]="address?.data | addressName"
          [linkCopy]="'Edit'"
          [subtitle]="infoMsg | translate"
          [link]="'/account/address/' + address?.id">

    <account-address-body [addressData]="address?.data"
                          class="block "></account-address-body>
</section2>
